// Local emulator mode (#1200). Opened from localhost with ?emulators, the CRM talks to the
// tools/local-e2e suite instead of production, so a change can be checked without live data.
// ?emulators=admin also signs in as the local admin straight away. Any other host never takes
// this path, whatever the URL says.
export const EMULATOR_HOST = "127.0.0.1";
export const EMULATOR_PORTS = { auth: 9099, firestore: 8085, functions: 5001 };

const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);
const PROJECT_NUMBER = "1081882026390";
const PROJECT_ID = "weeknightbite-83965";
export const LOCAL_ADMIN_UID = "crm-local-admin";

export function isEmulatorMode({ hostname, search }) {
  return LOCAL_HOSTNAMES.has(hostname) && new URLSearchParams(search).has("emulators");
}

export function wantsLocalAdminSignIn({ search }) {
  return new URLSearchParams(search).get("emulators") === "admin";
}

function base64Url(value) {
  return btoa(JSON.stringify(value)).replace(/=+$/, "").replace(/\+/g, "-").replace(/\//g, "_");
}

function unsignedJwt(payload) {
  return `${base64Url({ alg: "none", typ: "JWT" })}.${base64Url(payload)}.`;
}

// A custom token with { admin: true }, the claim the CRM and firestore.rules check. It is unsigned,
// so only the Auth emulator accepts it; production Auth rejects it.
export function localAdminCustomToken(nowSeconds = Math.floor(Date.now() / 1000)) {
  const serviceAccount = `crm-local-admin@${PROJECT_ID}.iam.gserviceaccount.com`;
  return unsignedJwt({
    iss: serviceAccount,
    sub: serviceAccount,
    aud: "https://identitytoolkit.googleapis.com/google.identity.identitytoolkit.v1.IdentityToolkit",
    iat: nowSeconds,
    exp: nowSeconds + 3600,
    uid: LOCAL_ADMIN_UID,
    claims: { admin: true }
  });
}

// The Functions emulator skips App Check verification but still rejects a call that enforces App
// Check and carries no token, so the CRM sends an unsigned one, as tools/local-e2e/bin/call.sh does.
export function fakeAppCheckToken(appId, nowSeconds = Math.floor(Date.now() / 1000)) {
  return unsignedJwt({
    iss: `https://firebaseappcheck.googleapis.com/${PROJECT_NUMBER}`,
    sub: appId,
    aud: [`projects/${PROJECT_NUMBER}`, `projects/${PROJECT_ID}`],
    iat: nowSeconds,
    exp: nowSeconds + 3600
  });
}
